import { searchApi, type SearchCategory, type SearchParams, type SearchSuggestionsResponse } from "@bw/shared/api";
import { useAuth } from "@bw/shared/hooks";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

export function useUnifiedSearch(params: SearchParams, enabled = true) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["unified-search", user?.uid ?? "guest", params],
    queryFn: () => searchApi.search(params),
    enabled: enabled && (params.category !== "players" || (params.q?.trim().length ?? 0) >= 2),
    staleTime: 30_000,
    refetchInterval: params.category === "facilities" && params.open_now ? 60_000 : false,
  });
}

export function useSearchSuggestions(q: string, category: SearchCategory, city: string | undefined, enabled: boolean): UseQueryResult<SearchSuggestionsResponse> {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["unified-search-suggestions", user?.uid ?? "guest", q, category, city],
    queryFn: () => searchApi.suggestions(q, category, city),
    enabled: enabled && q.trim().length >= 2,
    staleTime: 30_000,
  });
}
